import { useYAxisScale } from 'recharts'

export function useChartPayloadTop(payload) {
  const yScale = useYAxisScale()

  if (yScale && payload.length > 0) {
    return Math.min(...payload.map(item => yScale(item.value)))
  }
}
